import { SERVER_URL } from "settings";

export const resolveFileUrl = (url) => {
  const rawUrl = url || "";

  if (!rawUrl)
    return "";

  if (rawUrl.startsWith("http://") || rawUrl.startsWith("https://"))
    return rawUrl;

  if (!rawUrl.startsWith("/"))
    return rawUrl;

  return `${SERVER_URL}${rawUrl}`;
};
